import React, { useEffect, useState } from 'react';
import SiteBrandLink from './SiteBrandLink';
import PublicNavLinks from './PublicNavLinks';
import './PublicNav.css';

type PublicNavbarProps = {
  onLogoClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  children?: React.ReactNode;
};

const PublicNavbar: React.FC<PublicNavbarProps> = ({ onLogoClick, children }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return undefined;

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setOpen(false);
    };

    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKeyDown);

    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);

  const closeMenu = () => setOpen(false);

  return (
    <nav className="navbar">
      <div className="nav-inner">
        <SiteBrandLink onClick={onLogoClick} />
        <div
          id="public-nav-menu"
          className={`nav-links${open ? ' nav-links-open' : ''}`}
          onClick={(event) => {
            if ((event.target as HTMLElement).closest('a')) closeMenu();
          }}
        >
          <PublicNavLinks />
          {children}
        </div>
        <button
          type="button"
          className="nav-toggle"
          aria-expanded={open}
          aria-controls="public-nav-menu"
          aria-label={open ? 'Close menu' : 'Open menu'}
          onClick={() => setOpen((value) => !value)}
        >
          <span className="nav-toggle-bar" />
          <span className="nav-toggle-bar" />
          <span className="nav-toggle-bar" />
        </button>
      </div>
      {open ? (
        <button
          type="button"
          className="nav-backdrop"
          aria-label="Close menu"
          onClick={closeMenu}
        />
      ) : null}
    </nav>
  );
};

export default PublicNavbar;
